(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pr-luxe-home"] && !Shopify.designMode) return;
  try {
    
  class PoppyRossHeroCarousel extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-carousel-dot]'));
      this.currentIndex = 0;
      this.autoplayDelay = Number(this.dataset.autoplay) || 5000;

      this.querySelector('[data-carousel-previous]')?.addEventListener('click', () => this.show(this.currentIndex - 1));
      this.querySelector('[data-carousel-next]')?.addEventListener('click', () => this.show(this.currentIndex + 1));
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.show(index)));

      this.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') this.show(this.currentIndex - 1);
        if (event.key === 'ArrowRight') this.show(this.currentIndex + 1);
      });
      this.addEventListener('mouseenter', () => {
        this.isHovered = true;
        this.stopAutoplay();
      });
      this.addEventListener('mouseleave', () => {
        this.isHovered = false;
        this.startAutoplay();
      });
      this.addEventListener('focusin', () => {
        this.isFocused = true;
        this.stopAutoplay();
      });
      this.addEventListener('focusout', (event) => {
        if (this.contains(event.relatedTarget)) return;
        this.isFocused = false;
        this.startAutoplay();
      });

      this.touchStartX = null;
      this.addEventListener('touchstart', (event) => {
        this.isTouching = true;
        this.touchStartX = event.changedTouches[0].clientX;
        this.stopAutoplay();
      }, { passive: true });
      this.addEventListener('touchend', (event) => {
        if (this.touchStartX === null) return;

        const distance = event.changedTouches[0].clientX - this.touchStartX;
        this.touchStartX = null;
        this.isTouching = false;

        if (Math.abs(distance) > 45) {
          this.show(this.currentIndex + (distance < 0 ? 1 : -1));
        } else {
          this.startAutoplay();
        }
      }, { passive: true });

      this.startAutoplay();
    }

    disconnectedCallback() {
      this.stopAutoplay();
    }

    show(index) {
      if (this.slides.length < 2) return;
      this.currentIndex = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === this.currentIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', String(!isActive));
      });
      this.dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === this.currentIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', String(isActive));
      });
      this.startAutoplay();
    }

    startAutoplay() {
      this.stopAutoplay();
      if (
        this.slides.length < 2 ||
        this.isHovered ||
        this.isFocused ||
        this.isTouching ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ) return;
      this.autoplayTimer = window.setInterval(() => this.show(this.currentIndex + 1), this.autoplayDelay);
    }

    stopAutoplay() {
      if (this.autoplayTimer) window.clearInterval(this.autoplayTimer);
      this.autoplayTimer = undefined;
    }
  }

  if (!customElements.get('poppy-ross-hero-carousel')) {
    customElements.define('poppy-ross-hero-carousel', PoppyRossHeroCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
